<template>
  <div>
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="所属类别">
        <el-cascader
          class="cascader"
          v-model="selectedCategoryKeys"
          :options="categories"
          :props="props"
          :placeholder="form.category_str"
          @change="parentCateChanged">
        </el-cascader>
      </el-form-item>
      <el-form-item label="是否发布">
        <!-- 1上架 2下架 -->
        <el-switch v-model="state_bool"></el-switch>
      </el-form-item>
      <el-form-item label="是否带logo">
        <el-switch
          active-color="#13ce66"
          inactive-color="#A3A3A3"
          v-model="form.has_logo"
          :active-value="1"
          :inactive-value="0">
        </el-switch>
      </el-form-item>
      <el-form-item label="推荐相关">
        <el-checkbox label="置顶" v-model="is_top_bool"></el-checkbox>
      </el-form-item>
      <el-form-item label="内容标题">
        <name-lang :edit_lan="form.name" @lang_change="title_lang_change"></name-lang>
      </el-form-item>

      <el-form-item label="封面图片">
        <img
          v-if="form.cover"
          :src="form.cover.startsWith('/')?`${baseURL}${form.cover}`:form.cover.startsWith('http')?`${form.cover}`:`${baseURL}/${form.cover}`"
          class="avatar"
        />
        <el-button type="primary" @click="cover_upload" style="margin-top: 20px;">
          上传<i class="el-icon-upload el-icon--right"></i>
        </el-button>
      </el-form-item>
      <el-form-item label="视频">
        <video
          v-if="form.videoURL"
          :src="form.videoURL.startsWith('/')?`${baseURL}${form.videoURL}`:form.videoURL.startsWith('http')?`${form.videoURL}`:`${baseURL}/${form.videoURL}`"
          class="video" style="width: 99px;height: 99px;object-fit: contain;"
        />
        <el-button type="primary" @click="video_upload" style="margin-top: 20px;">
          上传<i class="el-icon-upload el-icon--right"></i>
        </el-button>
      </el-form-item>
      <el-form-item label="商品货号">
        <el-input v-model="form.goods_num"></el-input>
      </el-form-item>
      <el-form-item label="库存数量">
        <el-input v-model="form.store_num"  type="number"></el-input>
      </el-form-item>

      <el-form-item label="价格">
        <el-input v-model="form.price"></el-input>
      </el-form-item>
      <el-form-item label="图片相册">
        <div class="pics" style="display: flex;flex-wrap: wrap;">
          <div v-for="pic in form.pics_array" style="position: relative;">
            <img
              :src="pic.startsWith('/')?`${baseURL}${pic}`:pic.startsWith('http')?`${pic}`:`${baseURL}/${pic}`"
              class="avatar"
              style="margin-left:10px;margin-bottom: 10px;"
            />
            <el-button
              type="danger"
              icon="el-icon-delete"
              style="position: absolute;top: 0;right: 0"
              @click="delete_img(pic)"
              circle
            ></el-button>
          </div>
          <div
            class="pic-add avatar"
            style="background-color: lightgray; display: flex;align-items: center;justify-content: center;margin-left:10px;"
            @click="pic_upload"
          >
            <i class="el-icon-plus" style="font-size: 40px;"></i>
          </div>
        </div>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt/>
        </el-dialog>
      </el-form-item>
      <el-form-item label="颜色分类">
        <div class="color-class" style="display: inline-block;">
          <div style="display: flex;flex-wrap: wrap;">
            <div
              style="background-color: #F7F8FA;display: flex;position: relative; margin-right: 10px;margin-bottom: 10px; align-items: center;padding: 0 5px;"
              v-for="color in form.products"
              @click="color_select(color)"
              :class="color.selected?'color_selected_style':'color_unselectd_style'"
            >
              <img
                :src="color.product_cover.startsWith('/')?`${baseURL}${color.product_cover}`:color.product_cover.startsWith('http')?`${color.product_cover}`:`${baseURL}/${color.product_cover}`"
                alt=""
                style="width: 30px;height: 30px;object-fit: cover;"
              />
              <span style="margin-left: 5px;">{{lang_auto_trans(color.product_name)}}</span>
              <div style="display: flex; position: absolute;top: -5px;right: 0">
                <i class="el-icon-edit-outline" style="display: inline-block; font-size: 15px;" @click="edit_color(color)"></i>
                <i class="el-icon-delete" style="display: inline-block;font-size: 15px;" @click="del_color(color)"></i>
              </div>
            </div>
            <div
              class="color-add"
              style="background-color: lightgray;display: inline;text-align: center;padding: 0px;margin-left: 10px;width: 40px;height: 40px;"
              @click="color_add"
            >
              <i class="el-icon-plus" style="font-size: 15px;"></i>
            </div>
          </div>
          <div v-if="selected_color" style="display: flex;flex-wrap: wrap;margin-top: 10px;">
            <img
              v-for="pic in selected_color.pics_array"
              :src="pic.startsWith('/')?`${baseURL}${pic}`:pic.startsWith('http')?`${pic}`:`${baseURL}/${pic}`"
              class="avatar"
              style="margin-right:10px;width: 60px;height: 60px;object-fit: cover;"
            />
          </div>
        </div>
      </el-form-item>
      <el-form-item label="商品简介">
        <name-lang :edit_lan="form.info" @lang_change="info_lang_change"></name-lang>
      </el-form-item>
      <el-form-item label="内容描述">
        <quill-editor ref="myQuillEditor" v-model="form.description" :options="editorOptions"></quill-editor>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onAlter">保存更改</el-button>
        <el-button @click="onCancel">取消</el-button>
      </el-form-item>
    </el-form>

    <photo-center
      :photoCenterShow="photoCenterShow"
      :maxselected_num="maxselected_num"
      :source_type="source_type"
      @closeDialog="closePhotoCenter"
    ></photo-center>
    <good-color-set
      :goodColorSetShow="goodColorSetShow"
      :color="editing_color"
      @closeDialog="closeColorSet"
      @okColorEdit="okColorEdit"
    ></good-color-set>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import GoodColorSet from "../components/GoodColorSet/GoodColorSet.vue";
import PhotoCenter from "../components/PhotoCenter/PhotoCenter.vue";
import { quillEditor } from "vue-quill-editor";
import { all_category_list, baseURL, edit_goods } from "../api/api";
import eventBus from "../eventbus/eventbus";
import { event_msg_keys } from "../eventbus/eventkeys";
import NameLang from "../components/Lang/NameLang.vue";
import { getRandom8Num, lang_auto_trans } from "../utils";
import { PhotoChooseType, SourceType } from "../system/config";

export default {
  components: {
    quillEditor,
    PhotoCenter,
    NameLang,
    GoodColorSet
  },
  data() {
    return {
      SourceType,
      baseURL,
      lang_auto_trans,
      maxselected_num: 1,
      photo_select_type: PhotoChooseType.Unknow,
      source_type:SourceType.NoLimited,
      photoCenterShow: false,
      goodColorSetShow: false,
      state_bool: true,
      is_top_bool: false,
      // 编辑弹窗SKU模板，对齐后端ProductItem
      editing_color: {
        id: 0,
        product_name: '',
        product_cover: '',
        product_pics: '',
        pics_array: [],
        product_number: 0,
        price: 0
      },
      selected_color: null,
      form: {
        id: 0, // 新增固定0
        goods_num: "",
        name: "",
        info: "",
        category_id: "",
        category_ids: "",
        category_str: "",
        price: 0,
        store_num: 0,
        pics: "",
        pics_array: [],
        cover: "",
        videoURL:"",
        state: 1,
        state_bool: true,
        is_top: 0,
        is_top_bool: false,
        has_logo: 1,
        description: "",
        // 对齐后端req.Products 数组，废弃旧colors字符串
        products: [],
        colors: ""
      },
      props: {
        checkStrictly: true,
        multiple: true
      },
      categories: [],
      dialogImageUrl: "",
      dialogVisible: false,
      selectedCategoryKeys: [],
      editorOptions: {
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              ['blockquote', 'code-block'],
              [{ header: 1 }, { header: 2 }],
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ script: 'sub' }, { script: 'super' }],
              [{ indent: '-1' }, { indent: '+1' }],
              [{ direction: 'rtl' }],
              [{ size: ['small', false, 'large', 'huge'] }],
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              [{ color: [] }, { background: [] }],
              [{ font: [] }],
              [{ align: [] }],
              ['clean'],
              ['link', 'image', 'video']
            ],
            handlers: {
              image: this.imageHandler
            }
          }
        }
      }
    };
  },
  mounted() {
    this.getAllIds()
    this.$evt.on(event_msg_keys.img_selected_submit_noti, this.img_selected_submit_callback)
  },
  destroyed() {
    this.$evt.off(event_msg_keys.img_selected_submit_noti, this.img_selected_submit_callback)
  },
  methods: {
    closePhotoCenter() {
      this.photoCenterShow = false;
      this.photo_select_type = PhotoChooseType.Unknow
      this.source_type = SourceType.NoLimited
    },
    imageHandler() {
      this.photoCenterShow = true;
      this.maxselected_num = 999;
      this.photo_select_type = PhotoChooseType.Editor
      this.source_type = SourceType.NoLimited
    },
    async fillEditorImage(pics) {
      if (!pics.length) return
      const quill = this.$refs.myQuillEditor.quill
      const range = quill.getSelection()
      const index = range ? range.index : 0
      try {
        pics.forEach((pic, i) => {
          const url = pic.startsWith('/') ? `${this.baseURL}${pic}?q=30` : pic.startsWith('http') ? `${pic}?q=30` : `${this.baseURL}/${pic}?q=30`
          quill.insertEmbed(index + i, 'image', url)
        });
      } catch (error) {
        console.log('插入失败', error)
      }
    },
    onEditorChange({ quill, html, text }) {
      console.log('编辑器内容:', html)
    },
    img_selected_submit_callback(e) {
      const selected_imgs = e.imgs
      this.photoCenterShow = false
      switch (this.photo_select_type) {
        case PhotoChooseType.Cover:
          this.form.cover = selected_imgs[0].source
          break;
        case PhotoChooseType.Video:
          this.form.videoURL = selected_imgs[0].source
          break;
        case PhotoChooseType.Photo:
          const pics_array = selected_imgs.map(item => item.source)
          if (!this.form.pics_array || !this.form.pics_array.length) {
            this.form.pics_array = []
          }
          this.form.pics_array = [...new Set([...this.form.pics_array, ...pics_array])];
          this.form.pics = this.form.pics_array.join(',')
          break;
        case PhotoChooseType.Editor:
          {
            const pics_array = selected_imgs.map(item => item.source)
            this.fillEditorImage(pics_array);
          }
          break;
        default:
          break;
      }
      this.photo_select_type = PhotoChooseType.Unknow
       this.source_type = SourceType.NoLimited
    },
    cover_upload() {
      this.maxselected_num = 1;
      this.photo_select_type = PhotoChooseType.Cover
      this.source_type = SourceType.Image
      this.photoCenterShow = true;
    },
    video_upload(){
      this.maxselected_num = 1;
      this.photo_select_type = PhotoChooseType.Video
      this.source_type = SourceType.Video
      this.photoCenterShow = true
    },
    pic_upload() {
      this.maxselected_num = 999;
      this.photo_select_type = PhotoChooseType.Photo
      this.source_type = SourceType.Image
      this.photoCenterShow = true;
    },
    delete_img(pic) {
      this.form.pics_array = this.form.pics_array.filter(exist_pic => exist_pic !== pic)
      this.form.pics = this.form.pics_array.join(',')
      this.$forceUpdate()
    },
    // 提交保存，参数对齐后端GoodsEditReq
    onAlter() {
      this.form.state = this.state_bool ? 1 : 2
      this.form.is_top = this.is_top_bool ? 1 : 0
      // 接口直接携带products数组，后端接收 []ProductItem
      console.log('提交表单', this.form)
      edit_goods(this.form)
        .then(res => {
          this.$message({
            type: "success",
            message: '新增商品成功'
          });
          this.$router.back();
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: err
          });
        })
    },
    onCancel() {
      this.$router.back();
    },
    async getAllIds() {
      const categories_res = await all_category_list()
      this.categories = categories_res.tree
      this.categorysKeyAddForEach(this.categories)
    },
    parentCateChanged() {
      const ids = this.selectedCategoryKeys.map(key => key[key.length - 1])
      this.form.category_id = ids.join(',')
      this.form.category_ids = ids
      var finded_cates_name = []
      this.selectedCategoryKeys.forEach(idArr => {
        const endId = idArr[idArr.length - 1]
        this.search_cate_name(endId, this.categories, finded_cates_name)
      })
      this.form.category_str = finded_cates_name.join(',')
    },
    search_cate_name(id, cates, finded_cates_name) {
      cates.forEach(cate => {
        if (cate.id == id) {
          finded_cates_name.push(cate.name_lang)
        }
        if (cate.children) {
          this.search_cate_name(id, cate.children, finded_cates_name)
        }
      })
    },
    categorysKeyAddForEach(arr) {
      arr.forEach(item => {
        item.value = item.id;
        item.label = item.name_lang
        if (item.children.length) {
          this.categorysKeyAddForEach(item.children)
        } else if (item.children) {
          Reflect.deleteProperty(item, 'children');
        }
      })
    },
    title_lang_change(json_lans) {
      this.form.name = JSON.stringify(json_lans);
    },
    info_lang_change(json_lans) {
      this.form.info = JSON.stringify(json_lans);
    },
    color_select(color) {
      if (this.selected_color) {
        this.selected_color.selected = false
      }
      this.form.products.map(in_color => {
        in_color.selected = false
      })
      this.selected_color = color
      this.selected_color.pics_array = color.product_pics.split(",")
      this.selected_color.selected = true
    },
    color_add() {
      // 默认填充商品全局库存、价格给新增SKU
      this.editing_color.product_number = this.form.store_num
      this.editing_color.price = this.form.price
      this.goodColorSetShow = true
    },
    closeColorSet() {
      this.goodColorSetShow = false
    },
    okColorEdit(color) {
      this.goodColorSetShow = false;
      if (!this.form.products) {
        this.form.products = []
      }
      // 前端临时新增：id=0，生成唯一inner_id标识
      if (!color.id && !color.inner_id) {
        color.goods_id = this.form.id
        color.inner_id = `${getRandom8Num()}_${this.form.products.length}`
        color.selected = false
        this.form.products.push(color)
      } else {
        // 已有条目，更新
        let index = -1;
        if (color.id > 0) {
          index = this.form.products.findIndex(in_color => in_color.id === color.id);
        } else if (color.inner_id) {
          index = this.form.products.findIndex(in_color => in_color.inner_id === color.inner_id);
        }
        if (index !== -1) {
          this.form.products.splice(index, 1, { ...color })
          // 同步更新选中预览图
          if (this.selected_color && ((color.id && this.selected_color.id === color.id) || (color.inner_id && this.selected_color.inner_id === color.inner_id))) {
            this.selected_color.pics_array = color.pics_array
          }
        }
      }

      this.form.colors = JSON.stringify(this.form.products)

      this.form.pics = this.form.products.flatMap(p => p.product_pics || []).join(',')
     
      this.$forceUpdate()
    },
    edit_color(color) {
      this.editing_color = JSON.parse(JSON.stringify(color))
      this.goodColorSetShow = true
    },
    del_color(color) {
      // 区分数据库id / 前端临时inner_id删除
      if (color.id > 0) {
        this.form.products = this.form.products.filter(in_color => in_color.id !== color.id);
        if (this.selected_color && this.selected_color.id === color.id) {
          this.selected_color = null
        }
      } else if (color.inner_id) {
        this.form.products = this.form.products.filter(in_color => in_color.inner_id !== color.inner_id);
        if (this.selected_color && this.selected_color.inner_id === color.inner_id) {
          this.selected_color = null
        }
      }
      if (this.selected_color) {
        this.selected_color.pics_array = this.selected_color.product_pics.split(',')
      }

      this.form.pics = this.form.products.flatMap(p => p.product_pics || []).join(',')

      this.$forceUpdate()
    }
  }
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
  object-fit: cover;
}
.goodadd {
  margin-top: 20px;
}
.color_selected_style {
  border: red solid 1px;
}
.color_unselectd_style {
  border: lightgray solid 1px;
}
</style>